
const _ = require('lodash');
const ko = require('knockout');


class Model {
	constructor (params) {
		params = _.defaultsDeep({}, params, {
			// selected value
			value: null,

			// small list of options
			optionsShort: [],

			// expanded list of options
			optionsFull: [],

			// title for the `null` item
			optionsCaption: undefined,

			// special "expand" option title
			optionsExpandTitle: 'Показать все опции',

			// when this observable is `true`, control is forced to the full mode
			forceFullMode: false,

			// extra parameters for 'options' binding
			optionsText: 'text',
			optionsValue: 'value',

			// parameter to reset if change select value
			resetableParameter: null,

			// disable parameter for control
			enable: true,

			//function that invokes when user selects value
			onSelect: _.noop(),
		});

		this._params = params;

		this._specialExpandOption = {
			value: Math.random(),
		};

		this._optionsShort = ko.pureComputed(
			() => [].concat(ko.unwrap(params.optionsShort), this._specialExpandOption)
		);

		this._optionsFull = ko.pureComputed(() => ko.unwrap(params.optionsFull));

		this._mode = ko.map(
			ko.oneOf(['short', 'full']),
			(v) => this._shouldForceFullMode() ? 'full' : v
		);

		this._valueShort = ko.pureComputed({
			read: () => (this._mode() === 'full')
				? this._optionsValue(this._specialExpandOption)
				: ko.unwrap(params.value),
			write: (v) => (v === this._optionsValue(this._specialExpandOption))
				? this._mode('full')
				: params.value(v),
		})
			.extend({
				inheritEditable: params.value,
			});

		this._valueFull = params.value;

		this._enable = params.enable;

		this._optionsCaption = params.optionsCaption;

		this._resetableParameter = this._params.resetableParameter;

		this._valueFull.subscribe(() => {
			if (_.isFunction(params.onSelect)) {
				params.onSelect();
			}

			if (this._resetableParameter !== null && this._resetableParameter !== undefined) {
				this._resetableParameter();
			}
		});

		this._valueShort.subscribe(() => {
			if (this._resetableParameter !== null && this._resetableParameter !== undefined) {
				this._resetableParameter();
			}
		});
	}

	_optionsText (option) {
		if (option === this._specialExpandOption) {
			return this._params.optionsExpandTitle;
		}

		if (_.isString(this._params.optionsText)) {
			return _.get(option, this._params.optionsText);
		}

		return this._params.optionsText.call(null, option);
	}

	_optionsValue (option) {
		if (option === this._specialExpandOption) {
			return this._specialExpandOption.value;
		}

		if (_.isString(this._params.optionsValue)) {
			return _.get(option, this._params.optionsValue);
		}

		return this._params.optionsValue.call(null, option);
	}

	_shouldForceFullMode () {
		// We should force full mode if explicitly asked by the `fourceFullMode` option
		// of if the value is not found in short options

		const paramsForce = ko.unwrap(this._params.forceFullMode);

		if (paramsForce) {
			return true;
		}

		const paramsValue = ko.unwrap(this._params.value);

		if (paramsValue == null && this._params.optionsCaption) {
			return false;
		}

		const optionsShort = ko.unwrap(this._optionsShort);

		const valueFoundInShort = _.some(
			optionsShort,
			_.matchesProperty(this._params.optionsValue, paramsValue)
		);

		return !valueFoundInShort;
	}
}

module.exports = Model;

